module.exports = __webpack_public_path__ + "img/img181.b4b2f8de.png";